import { render, staticRenderFns } from "./Detail_param.vue?vue&type=template&id=be69903e&scoped=true&"
import script from "./Detail_param.vue?vue&type=script&lang=js&"
export * from "./Detail_param.vue?vue&type=script&lang=js&"
import style0 from "./Detail_param.vue?vue&type=style&index=0&id=be69903e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be69903e",
  null
  
)

export default component.exports